var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "coordinatorBox",
    attrs: {
      "id": "coordinator"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "contentLeft left"
  }, [_c('div', {
    staticClass: "publicTalk"
  }, [_c('div', {
    staticClass: "head-top"
  }, [_c('i', {
    staticClass: "iconfont icon-publictalk"
  }), _c('span', {
    staticClass: "titleSpan"
  }, [_vm._v(_vm._s(_vm.$t('conferenceHost.Speaker')))])]), _c('div', {
    staticClass: "head-content"
  }, [_c('div', {
    staticClass: "head-content-title"
  }, [_vm.userInfo.rtilCode ? _c('MainWindowSelect', {
    ref: "mainWindowSelect",
    attrs: {
      "partyCode": _vm.partyCode,
      "currentTypeShare": "pip",
      "partyInfo": _vm.userInfo,
      "nickNameInfo": _vm.nickNameInfo,
      "mainWindowList": _vm.mainWindowSelectList
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "videoBox"
  }, [_c('div', {
    staticClass: "speakerBox left",
    class: {
      isFullScreen: _vm.showSpeakerFullScreen,
      notShowFootBar: !_vm.State.showFootBar
    }
  }, [_c('NewAttendUser', {
    ref: "speakerVideo",
    attrs: {
      "nickName": _vm.State.speakerInfo ? _vm.State.speakerInfo.nickName : '',
      "tagName": _vm.tagNameInfo[_vm.State.speakerInfo ? _vm.State.speakerInfo.rtilCode : ''],
      "organization": _vm.State.speakerInfo ? _vm.State.speakerInfo.organization : '',
      "title": _vm.speakStream.id,
      "singChannel": _vm.speakStream,
      "userInfo": _vm.userInfo,
      "rtc": _vm.rtc,
      "isAudioLevel": _vm.isAudioLevel,
      "volume": _vm.voiceList[_vm.speakStream.id],
      "degreeHost": _vm.degreeHost[_vm.speakStream.id],
      "controlMute": _vm.State.speakerInfo ? _vm.State.speakerInfo.rtilCode == _vm.userInfo.rtilCode : '',
      "notShowEarphone": _vm.mainWindowType != 'Speaker',
      "showTitle": _vm.judgeShowTitle,
      "muteVideo": _vm.State.speakerInfo ? !_vm.State.cameraStatus[_vm.speakStream.id] : false,
      "muteAudio": _vm.State.speakerInfo ? !_vm.State.micStatus[_vm.speakStream.id] : false,
      "operateList": _vm.speakerOperateList,
      "asRoleList": _vm.returnRoleList,
      "currentRole": "setSpeaker",
      "liveInfo": _vm.rtilStatusObj[_vm.State.speakerInfo ? _vm.State.speakerInfo.rtilCode : ''] || {},
      "showMuteIcons": _vm.mainWindowType == 'Speaker' ? true : false
    },
    on: {
      "callback": _vm.attendCallback
    },
    scopedSlots: _vm._u([JSON.stringify(_vm.speakStream) != '{}' && _vm.mainWindowType == 'Speaker' ? {
      key: "videoBottom",
      fn: function () {
        return [_c('LiveSourceSelect', {
          ref: `liveSource${_vm.speakStream.id}`,
          attrs: {
            "allRList": _vm.allRList,
            "useNewUi": true,
            "partyCode": _vm.userInfo.realPartyCode,
            "nickName": _vm.State.speakerInfo ? _vm.State.speakerInfo.nickName : '',
            "rtilCode": _vm.speakStream.id,
            "memberId": _vm.speakStream.tid,
            "liveInfo": _vm.rtilStatusObj[_vm.speakStream.id]
          },
          on: {
            "callback": _vm.callbackByLiveSource
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }, [JSON.stringify(_vm.speakStream) == '{}' || !_vm.speakStream.id ? _c('div', {
    staticClass: "common"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('conferenceHost.noSpeakerDesign')))]), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('conferenceHost.designSpeaker')))])]) : _vm._e()])], 1), _c('div', {
    staticClass: "questionerBox right",
    class: {
      isFullScreen: _vm.showTalkFullScreen,
      notShowFootBar: !_vm.State.showFootBar
    }
  }, [_c('NewAttendUser', {
    ref: "talkInfoVideo",
    attrs: {
      "nickName": _vm.State.talkInfo ? _vm.State.talkInfo.nickName : '',
      "tagName": _vm.tagNameInfo[_vm.State.talkInfo ? _vm.State.talkInfo.rtilCode + '' : ''],
      "organization": _vm.State.talkInfo ? _vm.State.talkInfo.organization : '',
      "nameColor": "green",
      "title": _vm.State.talkInfo ? _vm.State.talkInfo.rtilCode + '' : '',
      "singChannel": _vm.talkStream,
      "userInfo": _vm.userInfo,
      "anywherePopShow": _vm.anywhereSettingShow,
      "talkInfo": _vm.State.talkInfo,
      "rtc": _vm.rtc,
      "isAudioLevel": _vm.isAudioLevel,
      "volume": _vm.voiceList[_vm.talkStream.id],
      "notShowEarphone": true,
      "degreeHost": _vm.degreeHost[_vm.talkStream.id],
      "showTitle": !_vm.State.talkInfo ? false : true,
      "muteVideo": _vm.State.talkInfo ? !_vm.State.cameraStatus[_vm.State.talkInfo.rtilCode] : false,
      "muteAudio": _vm.State.talkInfo ? !_vm.State.micStatus[_vm.State.talkInfo.rtilCode] : false,
      "asRoleList": ['setQuestionSpeaker', 'cancelQuestionSpeaker'],
      "currentRole": "interviewer",
      "controlMute": _vm.State.talkInfo ? _vm.State.talkInfo.rtilCode == _vm.userInfo.rtilCode : '',
      "operateList": _vm.talkOperate,
      "liveInfo": _vm.rtilStatusObj[_vm.State.talkInfo ? _vm.State.talkInfo.rtilCode : ''] || {}
    },
    on: {
      "callback": _vm.attendCallback
    },
    scopedSlots: _vm._u([_vm.talkStream.id ? {
      key: "videoBottom",
      fn: function () {
        return [_c('LiveSourceSelect', {
          ref: `liveSource${_vm.talkStream.id}`,
          attrs: {
            "allRList": _vm.allRList,
            "useNewUi": true,
            "partyCode": _vm.userInfo.realPartyCode,
            "nickName": _vm.State.talkInfo ? _vm.State.talkInfo.nickName : '',
            "rtilCode": _vm.talkStream.id,
            "memberId": _vm.allAccountIdByRtilCode[_vm.talkStream.id],
            "liveInfo": _vm.rtilStatusObj[_vm.talkStream.id] || {}
          },
          on: {
            "callback": _vm.callbackByLiveSource
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }, [JSON.stringify(_vm.talkStream) === '{}' || !_vm.talkStream.id ? _c('div', {
    staticClass: "common"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('conferenceHost.noQuestionerDesign')))]), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('conferenceHost.designQuestioner')))])]) : _vm._e(), _vm.showStartTalkButton ? _c('div', {
    staticClass: "bgBox"
  }, [_c('div', {
    staticClass: "bg"
  }), _c('el-button', {
    staticClass: "green",
    on: {
      "click": _vm.setReplaceQuestionSpeaker
    }
  }, [_vm._v("Let's Start talk")])], 1) : _vm._e()])], 1)])])]), _c('div', {
    staticClass: "questioner"
  }, [_c('div', {
    staticClass: "foot-top"
  }, [_c('i', {
    staticClass: "iconfont icon-questionerqueue opacity4"
  }), _vm._v(_vm._s(_vm.$t('conferenceHost.questionerQueue'))), _c('span', {
    staticClass: "opacity4"
  }, [_vm._v("(" + _vm._s(_vm.questionerList.length) + ")")])]), _c('div', {
    staticClass: "foot-content"
  }, _vm._l(8, function (i) {
    return _c('questioner', {
      key: i,
      ref: `source${_vm.questionerList[i - 1] ? _vm.questionerList[i - 1].rtilCode : ''}`,
      refInFor: true,
      attrs: {
        "movePips": _vm.movePips,
        "index": i,
        "tagNameInfo": _vm.tagNameInfo,
        "userInfo": _vm.userInfo,
        "rtilCode": _vm.rtilCode,
        "rtc": _vm.rtc,
        "isAudioLevel": _vm.isAudioLevel,
        "anywherePopShow": _vm.anywhereSettingShowMap[_vm.questionerList[i - 1] ? _vm.questionerList[i - 1].rtilCode : 0],
        "isAnyWhere": _vm.isAnyWhere[_vm.questionerList[i - 1] ? _vm.questionerList[i - 1].rtilCode : 0],
        "degreeHost": _vm.degreeHost[_vm.questionerList[i - 1] ? _vm.questionerList[i - 1].rtilCode : 0],
        "questionerInfo": _vm.questionerList[i - 1],
        "stream": _vm.returnStream(_vm.questionerList[i - 1]),
        "volume": _vm.voiceList[_vm.questionerList[i - 1] ? _vm.questionerList[i - 1].rtilCode : ''],
        "allRList": _vm.allRList,
        "liveInfo": _vm.rtilStatusObj[_vm.questionerList[i - 1] ? _vm.questionerList[i - 1].rtilCode : ''] || {}
      },
      on: {
        "callback": _vm.callbackByLiveSource,
        "callbackAttend": _vm.attendCallback
      }
    });
  }), 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showChatMessage || _vm.loadRaiseHand || _vm.loadAudience,
      expression: "(showChatMessage || loadRaiseHand || loadAudience)"
    }],
    staticClass: "contentRight right",
    class: {
      active: _vm.loadChatBox || _vm.loadRaiseHand || _vm.loadAudience
    }
  }, [_vm.userInfo.rtilCode && _vm.loadChatBox && _vm.showChatMessage ? _c('div', {
    staticClass: "chatBox"
  }, [_c('ChatMessage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showChatMessage,
      expression: "showChatMessage"
    }],
    attrs: {
      "userInfo": _vm.userInfo,
      "allPartyMembers": _vm.allPartyMembers,
      "chatPartyCode": _vm.userInfo.realPartyCode,
      "showComponent": _vm.showChatMessage,
      "nickNameInfo": _vm.nickNameInfo,
      "tagNameInfo": _vm.tagNameInfo
    },
    on: {
      "callback": _vm.chatCallback
    }
  })], 1) : _vm._e(), _c('raiseHandList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loadRaiseHand,
      expression: "loadRaiseHand"
    }],
    attrs: {
      "raiseHandList": _vm.raiseHandList,
      "tagNameInfo": _vm.tagNameInfo,
      "rtilCode": _vm.rtilCode,
      "userInfo": _vm.userInfo
    },
    on: {
      "changeHandList": _vm.changeHandList,
      "callback": _vm.chatCallback
    }
  }), _vm.loadAudience ? _c('Audience', {
    ref: "audience",
    attrs: {
      "userInfo": _vm.userInfo,
      "movePips": _vm.movePips,
      "questionerList": _vm.questionerList,
      "tagNameInfo": _vm.tagNameInfo
    },
    on: {
      "callback": _vm.attendCallback
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "audioBox"
  }, [_c('NewAttendUser', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    key: _vm.PrivateInfo.rtilCode,
    attrs: {
      "title": _vm.PrivateInfo.rtilCode + '',
      "rtc": _vm.rtc,
      "nickName": _vm.PrivateInfo.nickName,
      "singChannel": _vm.privateStream,
      "userInfo": _vm.userInfo,
      "muteVideo": !_vm.State.cameraStatus[_vm.PrivateInfo.rtilCode],
      "muteAudio": !_vm.State.micStatus[_vm.PrivateInfo.rtilCode]
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shareInfo,
      expression: "shareInfo"
    }],
    staticClass: "shareScreen"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.allScreen,
      expression: "allScreen"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.shareInfo ? _vm.shareInfo.nickName : '') + " " + _vm._s(_vm.$t('partylineGuest.isSharing')) + " "), _c('span', {
    on: {
      "click": _vm.switchToSmallVideo
    }
  }, [_vm._v(_vm._s(_vm.$t('commonFunction.switchToParty')))])]), _c('div', {
    staticClass: "videoBox",
    class: {
      smallVideo: !_vm.allScreen,
      fullScreen: _vm.showShareFullScreen,
      notShowFootBar: !_vm.State.showFootBar
    }
  }, [_c('NewAttendUser', {
    ref: "shareStreamBox",
    attrs: {
      "nickName": _vm.shareNickname,
      "title": _vm.shareTitle,
      "singChannel": _vm.shareStream,
      "isShare": true,
      "rtc": _vm.rtc,
      "volume": _vm.voiceList[_vm.shareStream.id],
      "degreeHost": _vm.degreeHost[_vm.shareStream.id],
      "isallScrren": _vm.allScreen,
      "userInfo": _vm.userInfo,
      "showMuteIcons": false,
      "shareInfo": _vm.shareInfo ? _vm.shareInfo : {},
      "muteVideo": !_vm.State.cameraStatus[_vm.shareStream.id]
    },
    on: {
      "callback": _vm.attendCallback
    }
  })], 1)]), _vm.setNameInfo.show ? _c('user-setting', {
    attrs: {
      "info": _vm.setNameInfo
    },
    on: {
      "setNickName": _vm.setNickName
    }
  }) : _vm._e(), _vm.setTagName.show ? _c('tag-name', {
    attrs: {
      "info": _vm.setTagName
    },
    on: {
      "saveTagName": _vm.saveTagName
    }
  }) : _vm._e(), _vm.anyWhereInfo.show ? _c('anywhereSetting', {
    attrs: {
      "anyWhereSetObj": _vm.anyWhereSettings[_vm.anyWhereInfo.rtilCode],
      "peerId": _vm.anyWherePeerIds[_vm.anyWhereInfo.rtilCode],
      "platForm": _vm.anyWherePlatForms[_vm.anyWhereInfo.rtilCode],
      "singChannel": _vm.anyWhereVideoAudioInfo,
      "userInfo": _vm.userInfo,
      "info": _vm.anyWhereInfo,
      "partyCode": '' + _vm.partyCode,
      "rtc": _vm.rtc
    },
    on: {
      "closeAnywherePreview": _vm.closeAnywherePreview
    }
  }) : _vm._e(), _vm.movePartyInfo.show ? _c('MovePartyList', {
    attrs: {
      "info": _vm.movePartyInfo,
      "userInfo": _vm.userInfo
    }
  }) : _vm._e(), _vm.batchMovePartyInfo.show ? _c('MovePartyTips', {
    attrs: {
      "info": _vm.batchMovePartyInfo,
      "userInfo": _vm.userInfo
    }
  }) : _vm._e(), _c('TipsDailog', {
    attrs: {
      "info": _vm.tipInfo
    }
  }), _c('tipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.collaborateInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlInvite(true);
      },
      "cancel": function ($event) {
        return _vm.controlInvite(false);
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('personalInfo.account')) + " " + _vm._s(_vm.collaborateInfo.info.fromEmail) + " " + _vm._s(_vm.$t('personalInfo.collaboratePopupLike')))])]), _c('div', {
    staticClass: "popupContent"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupAllow')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail2')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail3')))])])])]), _c('tipsDailog', {
    staticClass: "repeatJoin",
    attrs: {
      "width": "550px",
      "info": _vm.repeatInfo
    },
    on: {
      "save": function ($event) {
        _vm.repeatInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.repeatContent')))])])]), _c('EncoderInfo', {
    attrs: {
      "info": _vm.encoderInfo
    }
  }), _c('guide-page', {
    attrs: {
      "dialogVisible": _vm.State.guideObjShow
    }
  }), _c('Foot', {
    ref: "footDiv",
    attrs: {
      "camera": _vm.State.cameraStatus[_vm.userInfo.rtilCode],
      "mic": _vm.State.micStatus[_vm.userInfo.rtilCode],
      "rtcLoaded": true,
      "isShare": _vm.shareRtilCode ? true : false,
      "devicesInfo": _vm.devicesInfo,
      "showUnread": _vm.showUnread,
      "cameraDevice": _vm.devicesInfo.cameraList,
      "speakerDevice": _vm.devicesInfo.speakerList,
      "showIconArray": _vm.footList,
      "userInfo": _vm.userInfo,
      "rtc": _vm.rtc,
      "microphoneDevice": _vm.devicesInfo.microphoneList
    },
    on: {
      "eventCallback": _vm.dealFootEvent
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };